export default __webpack_public_path__ + "static/media/testi-bg.3862adca.jpg";